var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-root"}},[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c('router-view',{staticClass:"page-view"})],1),_c('FloatingMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }